import React, { useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Mensaje } from "../components/mensajes";
import { Loader, Dimmer } from "semantic-ui-react";
import useTable from "../components/useTable";
import {
  TableBody,
  TableRow,
  TableCell,
  InputAdornment,
} from "@material-ui/core";
import axios from "axios";
import useTableScroll from "../components/useTableScroll";

const CatalogoCliente = (props) => {
  let op = require("../../public/modulos/datos");
  let token = sessionStorage.getItem("jwtToken");
  const btnAcepta = useRef();
  const btnCancela = useRef();
  const txtCliente = useRef([]);
  const txtBuscar = useRef();
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [activate, setActivate] = useState(false);
  const [listaClientes, setListaClientes] = useState([]);
  const [clientesTodos, setClientesTodos] = useState([]);
  let values = {
    idagente: "",
    rif: "",
    nombre: "",
    reprelegal: "",
    tipoper: "",
    idalmacen: "",
    limitecredito: "",
    montocredito: ""
  };

  const headCells = [
    { label: "CODIGO", textAlign: "center" },
    { label: "RIF", textAlign: "center" },
    { label: "NOMBRE", textAlign: "center" },
    { label: "CEDULA", textAlign: "center" },
  ];

  const { TblContainer, TblHead } = useTableScroll(headCells);
  const handleSearch = (e) => {
    let target = e.target;
    let lista = [];

    if (target.value === "") {
      lista = clientesTodos;
    } else {
      lista = clientesTodos.filter((x) => {
        if (
          x.idagente.includes(target.value) ||
          x.rif.includes(target.value) ||
          x.nombre.toLowerCase().includes(target.value.toLowerCase()) ||
          x.reprelegal !== null && x.reprelegal.toLowerCase().includes(target.value.toLowerCase())
        ) {
          return x;
        }
      });
    }

    setListaClientes(lista);
  };

  const seleccionarRegistros = () => {
    let campos = "";
    let nomtab = "";
    let nomid = "";
    let condi = "";
    let orden = "";
    let endpoint = "";
    if (props.nomid !== 'vacio') {
      campos = "idagente, municipio, ciudad, trim(nombre) as nombre, trim(direccion) as direccion, rif, reprelegal, tipoper, idalmacen, celular, limitecredito, montocredito";
      nomtab = "agente";
      nomid = props.nomid;
      orden = "idagente desc";
      endpoint = `${op.conexion}/api/consulta/modeliorder?campos=${campos}&id=true&nomtab=${nomtab}&nomid=${nomid}&orden=${orden}`;
    } else {
      campos = "idagente, municipio, ciudad, trim(nombre) as nombre, trim(direccion) as direccion, rif, reprelegal, tipoper, idalmacen, celular";
      nomtab = "agente";
      condi = 'vendedor = false';
      orden = "idagente";
      endpoint = `${op.conexion}/api/consulta/selecionarregistrocondi?campos=${campos}&nomtab=${nomtab}&condi=${condi}&orden=${orden}`;
    }

    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.length > 0) {
            setListaClientes(response.data);
            setClientesTodos(response.data);
          }
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      })
      .finally(() => {
        setActivate(false);
      });
  };

  const blanquear = () => {
    setActivate(false);
    setListaClientes([]);
    setClientesTodos([]);
    values = {
      idagente: "",
      rif: "",
      nombre: "",
      reprelegal: "",
      tipoper: "",
      rifs: "",
      municipio: "",
      ciudad: "",
      repre: "",
      direccion: "",
      idalmacen: "",
      celular: "",
      limitecredito: "",
      montocredito: ""
    };
  };

  const seleccionarFila = (item, index) => {
    values = {
      idagente: item.idagente,
      rif: item.rif,
      nombre: item.nombre,
      reprelegal: item.reprelegal !== null ? item.reprelegal : 'N/S',
      tipoper: item.tipoper,
      rifs: item.rif.substring(1, 11),
      municipio: item.municipio,
      ciudad: item.ciudad,
      repre: item.reprelegal !== null ? item.reprelegal.substring(1, 9) : 'N/S',
      direccion: item.direccion,
      idalmacen: item.idalmacen,
      celular: item.celular,
      limitecredito: item.limitecredito,
      montocredito: item.montocredito
    };

    for (let i = 0; i < txtCliente.current.length; i++) {
      if (i === index) {
        txtCliente.current[i].style.backgroundColor = "lightskyblue";
      } else {
        if (txtCliente.current[i]) {
          txtCliente.current[i].style.backgroundColor = "white";
        }
      }
    }

    btnAcepta.current.focus();
  };

  const cancelar = () => {
    blanquear();
    props.onHideCancelar();
  };

  const seleccionarCliente = () => {
    props.onHideAceptaCatalogo(values);
  };

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
      backdrop="static"
      keyboard={false}
      onShow={() => {
        blanquear();
        seleccionarRegistros();
        txtBuscar.current.focus();
      }}
    >
      <Modal.Header className="azulGradiant2 header-modal">
        <div className="fw-bold text-light">
          <h3>Seleccionar {props.nomid}</h3>
        </div>
        <button
          ref={btnCancela}
          className="bg-transparent"
          style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }}
          onClick={cancelar}
        >
          <i className="far fa-window-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        <Mensaje
          mensaje={mensaje}
          onHide={() =>
            setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" })
          }
        />
        <Dimmer active={activate} inverted>
          <Loader inverted>Cargando...</Loader>
        </Dimmer>
        <div className="col-md-12" style={{ marginBottom: "10px" }}>
          <div className="row">
            <div className="input-group col-md-6 input-group-sm mb-3">
              <input
                type="text"
                onChange={handleSearch}
                className="form-control text-uppercase"
                ref={txtBuscar}
              />
              <button
                className="btn btn-info"
                style={{ pointerEvents: "none" }}
              >
                <i className="fa fa-search"></i>
              </button>
            </div>
          </div>
        </div>
        <div className="col-md-12" style={{ margin: "auto" }}>
          <TblContainer
            container={{
              height: 200,
              width: "100%",
              overflow: "auto",
              padding: "2px",
              fontSizeAdjust: "0.6",
            }}
          >
            <TblHead />

            <TableBody>
              {listaClientes &&
                listaClientes.map((item, index) => (
                  <TableRow
                    key={index}
                    ref={(el) => (txtCliente.current[index] = el)}
                    style={{ backgroundColor: "white" }}
                    onClick={() => seleccionarFila(item, index)}
                  >
                    <TableCell className="py-2 text-center">
                      {item.idagente}
                    </TableCell>
                    <TableCell className="py-2 text-center">
                      {item.rif}
                    </TableCell>
                    <TableCell className="py-2 text-start">
                      {item.nombre}
                    </TableCell>
                    <TableCell className="py-2 text-center">
                      {item.reprelegal !== null ? item.reprelegal : 'N/S'}
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </TblContainer>
          {/*           <TblPagination /> */}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          ref={btnAcepta}
          className="btn btn-sm btn-success rounded-pill"
          style={{ margin: "5px" }}
          onClick={seleccionarCliente}
        >
          <i className="fas fa-check-circle"> Aceptar</i>{" "}
        </button>
        <button
          ref={btnCancela}
          onClick={cancelar}
          className="btn btn-sm btn-danger rounded-pill"
        >
          <i className="fas fa-window-close"> Cancelar</i>
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default CatalogoCliente;



// WEBPACK FOOTER //
// ./src/catalogos/catalogoCliente.js